const issue_explanations = {
    'cta_conflict': {
      title: 'Conflicting CTAs (Messaging)',
      description: 'Contacts received two or more calls-to-action within a short time that contradict or compete with each other — either across emails or within a single message.',
      impacts: [
        'Confuses prospects and reduces conversion clarity ("Should I start a trial or book a demo?").',
        'Splits attention between goals and lowers overall response rates.',
        'Creates inconsistent positioning if one CTA assumes different buyer readiness.',
        'Fixing these leads to cleaner funnels and a single, coherent customer action per stage.',
      ],
      recommendation: 'In short: conflicting CTAs blur your conversion path and weaken campaign intent.'
    },
    'frequency_issue': {
      title: 'Same-Tool Overlaps (Repetition)',
      description: 'Multiple messages were sent from the same ESP or marketing automation tool within 24 hours to the same contact.',
      impacts: [
        'Indicates workflow misfires — duplicate triggers, missing suppression logic, or parallel automations.',
        'Leads to fatigue and unsubscribes when contacts feel spammed by the same sender.',
        'Damages deliverability and sender reputation over time.',
        'Often easy to fix by adding delay rules or frequency caps in the tool itself.',
      ],
      recommendation: 'In short: same-tool overlaps waste attention and reduce trust in your brand.'
    },
    'communication_overlap': {
      title: 'Cross-Tool Overlaps (Coordination)',
      description: 'Messages were sent by different tools (e.g., HubSpot + Amplemarket, or eSputnik + Userpilot) to the same contact within 24 hours.',
      impacts: [
        'Highlights lack of orchestration between your marketing, sales, and product systems.',
        'Creates mixed timing and tone — one message may invite a demo while another assumes a trial is already in progress.',
        'Often signals that data syncs or lifecycle triggers are misaligned across platforms.',
        'Fixing it leads to more consistent multi-channel journeys and better conversion rates.',
      ],
      recommendation: 'In short: cross-tool overlaps are a sign your GTM stack is working in silos.'
    },
    'mrr_attribution': {
      title: 'Campaign MRR Attribution',
      description: 'This campaign email was the last touch before a Stripe subscription was created within the attribution window.',
      impacts: [
        'Identifies which campaigns directly precede revenue-generating actions.',
        'Helps prioritize high-performing campaigns and sequences for future investment.',
        'Reveals the typical time gap between email engagement and subscription conversion.',
        'Enables data-driven decisions about campaign ROI and resource allocation.',
      ],
      recommendation: 'In short: campaign attribution links your email efforts to actual MRR impact.'
    },
    'mrr_attribution_cta': {
      title: 'CTA MRR Attribution',
      description: 'This specific call-to-action in an email was the last touch before a Stripe subscription was created.',
      impacts: [
        'Pinpoints which CTAs are most effective at driving subscription conversions.',
        'Helps optimize CTA copy, placement, and targeting for maximum revenue impact.',
        'Compares CTA performance across different campaigns and email types.',
        'Guides A/B testing priorities by showing which CTAs correlate with higher MRR.',
      ],
      recommendation: 'In short: CTA attribution shows which specific actions in your emails drive revenue.'
    },
    'mrr_read_attribution': {
      title: 'Campaign MRR Attribution',
      description: 'This campaign email was the last touch before a Stripe subscription was created within the attribution window.',
      impacts: [
        'Identifies which campaigns directly precede revenue-generating actions.',
        'Helps prioritize high-performing campaigns and sequences for future investment.',
        'Reveals the typical time gap between email engagement and subscription conversion.',
        'Enables data-driven decisions about campaign ROI and resource allocation.',
      ],
      recommendation: 'In short: campaign attribution links your email efforts to actual MRR impact.'
    },
    'mrr_read_attribution_cta': {
      title: 'CTA MRR Attribution',
      description: 'This specific call-to-action in an email was the last touch before a Stripe subscription was created.',
      impacts: [
        'Pinpoints which CTAs are most effective at driving subscription conversions.',
        'Helps optimize CTA copy, placement, and targeting for maximum revenue impact.',
        'Compares CTA performance across different campaigns and email types.',
        'Guides A/B testing priorities by showing which CTAs correlate with higher MRR.',
      ],
      recommendation: 'In short: CTA attribution shows which specific actions in your emails drive revenue.'
    }
  };

  export { issue_explanations };